import { render, staticRenderFns } from "./complaintResult.vue?vue&type=template&id=43bcef38&scoped=true&"
import script from "./complaintResult.vue?vue&type=script&lang=js&"
export * from "./complaintResult.vue?vue&type=script&lang=js&"
import style0 from "./complaintResult.vue?vue&type=style&index=0&id=43bcef38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bcef38",
  null
  
)

export default component.exports